import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

@Entity()
export class BHBuildifyFlexConfiguration extends AdornisEntity {
  static override _class = 'BHBuildifyFlexConfiguration';

  @Field(() => String)
  flexDirection?: string;

  @Field(() => String)
  rowGap?: string;

  @Field(() => String)
  columnGap?: string;

  @Field(() => String)
  justifyContent?: string;

  @Field(() => String)
  alignItems?: string;

  @Field(() => String)
  backgroundColor?: string;

  @Field(() => String)
  borderRadius?: string;

  @Field(() => String)
  height?: string;

  @Field(() => String)
  padding?: string;

  @Field(() => String)
  margin?: string;
}
